import { createFileRoute, redirect } from '@tanstack/react-router';
import { PlaceholderScreen } from '@/components/layout/placeholder-screen';
import { useAuthStore } from '@/stores/auth';
import { hasPlaceholderPermission } from '@/lib/permissions';

export const Route = createFileRoute('/placeholder')({
  beforeLoad: async () => {
    const { isInitialized, initialize } = useAuthStore.getState();

    if (!isInitialized) {
      await initialize();
    }

    const { isAuthenticated, user } = useAuthStore.getState();

    if (!isAuthenticated || !user) {
      throw redirect({ to: '/login' });
    }

    if (!hasPlaceholderPermission(user)) {
      throw redirect({ to: '/people' });
    }
  },
  component: PlaceholderPage,
});

function PlaceholderPage() {
  const user = useAuthStore((s) => s.user);

  return (
    <PlaceholderScreen
      name={user?.employee?.firstName || user?.email || ''}
      avatarUrl={user?.employee?.avatarUrl}
    />
  );
}
